module.exports = __webpack_public_path__ + "img/RetuscheOriginal.5f2caeb6.jpg";